import Cookies from 'js-cookie';

const AUTH_CODE = [401, 420];
const expires = 180;
const domain = (import.meta.env.VITE_FORCE_TRANSFER_LOGIN === 'yes' || import.meta.env.DEV)
  ? location.hostname
  : import.meta.env.VITE_COOKIE_DOMAIN;
const redirectKey = 'atom_redirect';
const userKey = 'atom_user';
const fileHost = import.meta.env.VITE_FILE_HOST;

const normalizePhoto = (value: unknown) => {
  const raw = String(value ?? '').trim();

  if (!raw) {
    return '';
  }

  if (raw.startsWith(fileHost)) {
    const path = raw.slice(fileHost.length);

    return path.startsWith('/') ? path : `/${path}`;
  }

  if (/^https?:\/\//.test(raw)) {
    return raw;
  }

  return raw.startsWith('/') ? raw : `/${raw}`;
};

export const isLogin = () => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    return !!Cookies.get(userKey);
  }
};

export const getUser = () => {
  try {
    const user = JSON.parse(Cookies.get(userKey) || '{}');

    return user;
  }
  catch (err) {
    return {};
  }
};

export const setUser = (info: Record<string, any>) => {
  const nextUser = {
    ...(info || {}),
    photo: normalizePhoto(info?.photo),
  };

  Cookies.set(userKey, JSON.stringify(nextUser), {
    path: '/',
    expires,
    domain,
  });
};

export const clearUser = () => {
  Cookies.remove(userKey, {
    path: '/',
    domain,
  });
};

export const gotoLogin = async (from = '/') => {
  setRedirectUrl(from);

  if (import.meta.env.VITE_FORCE_TRANSFER_LOGIN === 'yes' || import.meta.env.DEV) {
    // 开发环境走中转逻辑，以生产换件为跳板

    const base = `${window.location.protocol}//${window.location.host}`;
    const redirect = `${base}/callback?from=${encodeURIComponent(from)}`;
    const loginPath = `${import.meta.env.VITE_LOGIN_CALLBACK_URL}?transfer_redirect=${encodeURIComponent(redirect)}`;

    window.location.replace(loginPath);
  }
  else {
    // 生产和测试环境走正式逻辑

    window.location.replace(import.meta.env.VITE_AUTH_BASE_URL);
  }
};

export const gotoLogout = (from: string) => {
  clearUser();

  window.location.replace(`${import.meta.env.VITE_LOGOUT_URL}?redirect_uri=${encodeURIComponent(from)}`);
};

export const isAuthCode = (code: number) => AUTH_CODE.includes(code);

export function getRedirectUrl() {
  const url = Cookies.get(redirectKey) || '';

  Cookies.remove(redirectKey, {
    path: '/',
    domain,
  });

  return url;
}

export function setRedirectUrl(url: string) {
  if (url) {
    Cookies.set(redirectKey, url, {
      path: '/',
      expires,
      domain,
    });
  }
}
